(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbw-collection"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   bbw-collection.js  →  paste inside {% javascript %}
   ============================================================ */
(function(){
  'use strict';
  var root = document.querySelector('#bbw-root'); if(!root) return;
  var GAS_URL = 'https://script.google.com/macros/s/AKfycbyanEQrCbDKalaOE2upeZVhGhSX0kWJk4X9-YqqQ6Qaf0-VwftKvippvvUxeqRtqBgRjw/exec';

  /* notes data map (id -> {name,en,notes,spec,date,accent,img}) */
  var NOTES = {};
  try { NOTES = JSON.parse(root.querySelector('[data-bbw-notes]').textContent); } catch(e){}

  /* ---------- helpers ---------- */
  function money(cents){
    // mirror theme money format; simple NT$ fallback
    return 'NT$' + (Math.round(cents/100)).toLocaleString('en-US');
  }
  function toastEl(){ return root.querySelector('[data-toast]'); }
  var tt=null;
  function toast(msg){ var t=toastEl(); if(!t) return; t.textContent=msg; t.classList.add('is-show'); clearTimeout(tt); tt=setTimeout(function(){t.classList.remove('is-show');},1600); }
  function pulse(el, cls, ms){ if(!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function(){ el.classList.remove(cls); }, ms); }
  function flashAdd(el){
    if(!el) return;
    pulse(el.querySelector('.bbw-vrow-plus, .bbw-prow-plus') || el, 'bbw-added', 660);
    var card = el.closest('[data-pid]');
    if(card) pulse(card.querySelector('[data-card-badge]'), 'bbw-badge-pop', 520);
  }

  /* ---------- CART (Shopify AJAX) ---------- */
  // qty keyed by variant id (mirrors cart line quantities we set)
  var qty = {};
  function setQty(vid, n){
    n = Math.max(0, Math.min(10, n));
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: String(vid), quantity: n })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      qty[vid] = n;
      syncVariant(vid, n);
      paintCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart})); // hook for aj-cart-bar
      return cart;
    })
    .catch(function(){ /* if line not in cart yet, change.js may 404 -> fall back to add */ });
  }
  function addOne(vid){
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items:[{ id:String(vid), quantity:1 }] })
    })
    .then(function(r){ return r.ok; })
    .then(function(ok){
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        var line = cart.items.filter(function(i){return String(i.variant_id)===String(vid);})[0];
        if(line){
          qty[vid] = line.quantity;
          syncVariant(vid, qty[vid]);
          paintCart(cart);
          document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
        }
        return ok && !!line;   // true only if the line really landed in the cart
      });
    });
  }

  /* ---------- single-product (no-variant) direct add — wired independently ---------- */
  function wireDirect(btn){
    if(btn.__wd) return; btn.__wd=true;
    var vid = btn.dataset.vid;
    btn.addEventListener('click', function(e){
      if(e.target.closest('[data-step]')) return;          // stepper handles its own taps
      e.preventDefault(); e.stopPropagation();
      if((qty[vid]||0)>0) return;
      addOne(vid)
        .then(function(ok){ if(ok){ toast('✓ ' + (btn.dataset.name||'') + ' 已加入購物車'); flashAdd(btn); } else { toast('這個商品目前無法加入'); } })
        .catch(function(){ toast('加入失敗,請再試一次'); });
    });
    btn.querySelectorAll('[data-step]').forEach(function(s){
      s.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        setQty(vid, (qty[vid]||0) + parseInt(s.dataset.step,10));
      });
    });
    if((qty[vid]||0)>0){ btn.classList.add('is-active'); var c=btn.querySelector('.bbw-step-n'); if(c) c.textContent=qty[vid]; }
  }
  root.querySelectorAll('.bbw-add-direct').forEach(wireDirect);

  function syncVariant(vid, n){
    root.querySelectorAll('[data-variant][data-vid="'+vid+'"]').forEach(function(row){
      row.classList.toggle('is-active', n>0);
      var c=row.querySelector('.bbw-step-n'); if(c) c.textContent = n||1;
    });
    // card badge (sum of that product's variants)
    root.querySelectorAll('[data-pid]').forEach(function(card){
      var total=0;
      card.querySelectorAll('[data-variant]').forEach(function(r){ total += (qty[r.dataset.vid]||0); });
      var b=card.querySelector('[data-card-badge]');
      if(b){ if(total>0){ b.classList.add('is-show'); b.querySelector('span').textContent=total; } else b.classList.remove('is-show'); }
    });
  }
  function paintCart(cart){
    var bar=root.querySelector('[data-cartbar]'); if(!bar||!cart) return;
    var n=cart.item_count, total=cart.total_price;
    bar.classList.toggle('is-show', n>0);
    var cn=root.querySelector('[data-cart-count]'), ct=root.querySelector('[data-cart-total]');
    if(cn) cn.textContent = n+' 件'; if(ct) ct.textContent = money(total);
  }

  /* wire any [data-variant] element (card row, direct-add card, modal row) */
  function wireVariant(el){
    if(el.__w) return; el.__w=true;
    var vid=el.dataset.vid;
    el.querySelectorAll('[data-add]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        // tap feedback only on an actual + glyph button (not the wide add-direct)
        var plusBtn = el.querySelector('.bbw-vrow-plus, .bbw-prow-plus');
        if(!plusBtn && btn.querySelector && btn.querySelector('.bbw-plus')) plusBtn = btn;
        if(plusBtn){ plusBtn.classList.remove('bbw-is-tapped'); void plusBtn.offsetWidth; plusBtn.classList.add('bbw-is-tapped'); setTimeout(function(){ plusBtn.classList.remove('bbw-is-tapped'); }, 360); }
        if((qty[vid]||0)>0) return;
        addOne(vid).then(function(ok){ if(ok){ toast('✓ ' + (el.dataset.name||'') + (el.dataset.fmt?(' · '+el.dataset.fmt):'') + ' 已加入'); flashAdd(el); } else { toast('這個商品目前無法加入'); } }).catch(function(){ toast('加入失敗,請再試一次'); });
      });
    });
    el.querySelectorAll('[data-step]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var cur=qty[vid]||0; var d=parseInt(btn.dataset.step,10);
        setQty(vid, cur+d);
      });
    });
    // restore on (re)mount
    if((qty[vid]||0)>0){ el.classList.add('is-active'); var c=el.querySelector('.bbw-step-n'); if(c) c.textContent=qty[vid]; }
  }
  root.querySelectorAll('.bbw-card [data-variant]:not(.bbw-add-direct)').forEach(wireVariant);

  /* ---------- 看商品 expand ---------- */
  root.querySelectorAll('[data-see]').forEach(function(b){
    b.addEventListener('click', function(){
      var card=b.closest('.bbw-card'); card.classList.toggle('is-see-open');
      b.querySelector('.bbw-see-l').textContent = card.classList.contains('is-see-open') ? '收起' : '看商品';
    });
  });

  /* ---------- 請 Ann 介紹 → 想看排行 board (exact main-grid contract: ?id=<handle>&name=<title>) ---------- */
  var WANT_KEY = 'aj_want_';
  function wantDone(b){ b.classList.add('is-sent'); var t=b.querySelector('.bbw-ann-text'); if(t) t.textContent='已送出 · Ann 直播介紹'; }
  root.querySelectorAll('[data-ann]').forEach(function(b){
    var id = b.dataset.handle || '';
    try{ if(localStorage.getItem(WANT_KEY + id)) wantDone(b); }catch(e){}
    b.addEventListener('click', function(){
      if(b.classList.contains('is-sent')) { toast('已經送出囉,Ann 會介紹 ☺'); return; }
      fetch(GAS_URL + (GAS_URL.indexOf('?') > -1 ? '&' : '?')
            + 'id='   + encodeURIComponent(id)
            + '&name='+ encodeURIComponent(b.dataset.title || ''),
            { method:'GET', mode:'no-cors' }).catch(function(){});
      try{ localStorage.setItem(WANT_KEY + id, '1'); }catch(e){}
      wantDone(b);
      toast('已送出 ☺ Ann 會在直播介紹這支');
    });
  });

  /* ---------- PRODUCT MODAL (chips) ---------- */
  var chips=root.querySelectorAll('[data-ptype]');

  /* ---------- theme filter: scent family + series (facets) ---------- */
  var cards=root.querySelectorAll('.bbw-card');
  var fpills=root.querySelectorAll('[data-filter]');
  var emptyEl=root.querySelector('[data-empty]');
  function activeVals(kind){ var out=[]; fpills.forEach(function(p){ if(p.classList.contains('is-on') && p.dataset.filter===kind) out.push(p.dataset.val); }); return out; }
  function matchFacet(fam, ser, famSel, serSel){
    var okF = famSel.length===0 || famSel.indexOf(fam||'')>-1;
    var okS = serSel.length===0 || serSel.indexOf(ser||'')>-1;
    return okF && okS;
  }
  function filterRows(container){
    var famSel=activeVals('fam'), serSel=activeVals('ser');
    if(!famSel.length && !serSel.length) return;
    container.querySelectorAll('.bbw-prow').forEach(function(row){
      if(!matchFacet(row.dataset.family, row.dataset.series, famSel, serSel)) row.remove();
    });
  }
  function recomputeChips(){
    chips.forEach(function(chip){
      var t=chip.dataset.ptype, count=0;
      cards.forEach(function(card){
        if(card.style.display==='none') return;
        if(t==='__acc__'){ if(card.classList.contains('is-single')) count++; }
        else if(!card.classList.contains('is-single') && (card.dataset.types||'').indexOf('|'+t+'|')>-1) count++;
      });
      var ne=chip.querySelector('.bbw-chip-n'); if(ne) ne.textContent=count;
      chip.style.display = count>0 ? '' : 'none';
    });
  }
  function applyFilter(){
    var famSel=activeVals('fam'), serSel=activeVals('ser'), anyVisible=false;
    cards.forEach(function(card){
      var show=matchFacet(card.dataset.family, card.dataset.series, famSel, serSel);
      card.style.display = show ? '' : 'none';
      if(show) anyVisible=true;
    });
    recomputeChips();
    if(emptyEl) emptyEl.hidden = anyVisible;
  }
  fpills.forEach(function(p){ p.addEventListener('click', function(){ p.classList.toggle('is-on'); applyFilter(); }); });
  var pmodal=root.querySelector('[data-pmodal]'),
      pmBody=pmodal?pmodal.querySelector('.bbw-sheet-body'):null,
      pmBd=root.querySelector('[data-pmodal-bd]'),
      pmClose=pmodal?pmodal.querySelector('[data-pmodal-close]'):null;
  var activeChip=null;
  function openP(t, chip){
    if(!pmodal||!pmBody) return;
    var tpl=root.querySelector('[data-pmodal-tpl="'+(window.CSS&&CSS.escape?CSS.escape(t):t)+'"]')
            || [].slice.call(root.querySelectorAll('[data-pmodal-tpl]')).filter(function(x){return x.getAttribute('data-pmodal-tpl')===t;})[0];
    if(!tpl) return;
    pmBody.innerHTML =
      '<div class="bbw-pmodal-head"><div class="bbw-pmodal-eye">商品</div>'+
      '<h2 class="bbw-pmodal-title">'+tpl.dataset.cn+'<span class="bbw-pmodal-n"></span></h2></div>'+
      '<div class="bbw-plist">'+tpl.innerHTML+'</div>';
    filterRows(pmBody);                                  // respect active family/series facets
    var n=pmBody.querySelectorAll('.bbw-prow').length;
    var nEl=pmBody.querySelector('.bbw-pmodal-n'); if(nEl) nEl.textContent=n+' 款';
    pmBody.querySelectorAll('[data-variant]').forEach(function(el){ el.__w=false; wireVariant(el); });
    pmBody.querySelectorAll('[data-open-notes]').forEach(bindNotesBtn);
    chips.forEach(function(c){ c.classList.toggle('is-on', c===chip); }); activeChip=chip;
    requestAnimationFrame(function(){ pmBd.classList.add('is-show'); pmodal.classList.add('is-show'); root.classList.add('bbw-has-sheet'); });
  }
  function closeP(){ if(!pmodal) return; pmodal.classList.remove('is-show'); pmBd.classList.remove('is-show'); root.classList.remove('bbw-has-sheet'); if(activeChip)activeChip.classList.remove('is-on'); activeChip=null; setTimeout(function(){ if(!pmodal.classList.contains('is-show')) pmBody.innerHTML=''; },500); }
  chips.forEach(function(c){ c.addEventListener('click', function(){ openP(c.dataset.ptype, c); }); });
  if(pmBd) pmBd.addEventListener('click', closeP);
  if(pmClose) pmClose.addEventListener('click', closeP);

  /* ---------- 香香筆記 sheet (built from NOTES map) ---------- */
  var nsheet=root.querySelector('[data-nsheet]'),
      nBody=nsheet?nsheet.querySelector('.bbw-sheet-body'):null,
      nBd=root.querySelector('[data-nsheet-bd]'),
      nClose=nsheet?nsheet.querySelector('[data-nsheet-close]'):null;
  function md(line){
    // **x** -> highlight, _x_ -> soft em ; leading ! -> bold line
    var bold = /^!/.test(line); if(bold) line=line.replace(/^!\s*/,'');
    line = line.replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>').replace(/_(.+?)_/g,'<em>$1</em>');
    return '<p'+(bold?' class="bbw-n-strong"':'')+'>'+line+'</p>';
  }
  function specHTML(spec){
    if(!spec) return '';
    var cols=['TOP','HEART','BASE'];
    var parts=spec.split(';').map(function(s){return s.trim();}).filter(Boolean);
    var inner=parts.map(function(p,i){ var kv=p.split('|'); return '<div class="bbw-spec-col"><div class="bbw-spec-t">'+(cols[i]||'')+'</div><div class="bbw-spec-cn">'+(kv[0]||'').trim()+'</div><div class="bbw-spec-en">'+((kv[1]||'').trim())+'</div></div>'; }).join('');
    return '<div class="bbw-spec"><div class="bbw-spec-bar"></div><div class="bbw-spec-labels">'+inner+'</div></div>';
  }
  function openNotes(pid){
    var d=NOTES[pid]; if(!d||!nsheet||!nBody){ return; }
    try {
    nsheet.style.setProperty('--c-heart', d.accent||'#E8A8C8');
    var rawNotes = d.notes;
    if (rawNotes && typeof rawNotes === 'object') { rawNotes = rawNotes.value || rawNotes.children || JSON.stringify(rawNotes); }
    rawNotes = (rawNotes == null) ? '' : String(rawNotes);
    var body = rawNotes.split(/\n+/).map(function(l){return l.trim();}).filter(Boolean).map(md).join('');
    nBody.innerHTML =
      '<div class="bbw-nt-hero">'+(d.img?'<img class="bbw-nt-img" src="'+d.img+'" alt="">':'')+
        '<div class="bbw-nt-meta"><div class="bbw-nt-eye">香香筆記'+(d.date?' · '+d.date:'')+'</div>'+
        '<h2 class="bbw-nt-name">'+(d.name||'')+'</h2>'+(d.en?'<div class="bbw-nt-en">'+d.en+'</div>':'')+'</div></div>'+
      '<div class="bbw-notes">'+specHTML(d.spec)+'<div class="bbw-notes-body">'+body+'</div>'+
        '<div class="bbw-notes-sig">— Ann 親自試香</div></div>';
    requestAnimationFrame(function(){ nBd.classList.add('is-show'); nsheet.classList.add('is-show'); root.classList.add('bbw-has-sheet'); });
    } catch(err){ /* never let a malformed note kill the sheet */ }
  }
  function closeNotes(){ nsheet.classList.remove('is-show'); nBd.classList.remove('is-show'); if(!pmodal.classList.contains('is-show')) root.classList.remove('bbw-has-sheet'); setTimeout(function(){ if(!nsheet.classList.contains('is-show')) nBody.innerHTML=''; },500); }
  function bindNotesBtn(b){ b.addEventListener('click', function(e){ e.stopPropagation(); openNotes(b.dataset.pid); }); }
  root.querySelectorAll('.bbw-card [data-open-notes]').forEach(bindNotesBtn);
  if(nBd) nBd.addEventListener('click', closeNotes);
  if(nClose) nClose.addEventListener('click', closeNotes);

  /* ---------- PDP-in-modal (香香問題 / 可以問Ann) — clone the inline-rendered PDP, no ATC ---------- */
  var pdpSheet=root.querySelector('[data-pdp]'), pdpBd=root.querySelector('[data-pdp-bd]'),
      pdpBody=pdpSheet?pdpSheet.querySelector('[data-pdp-body]'):null;
  function runScripts(scope){ scope.querySelectorAll('script').forEach(function(old){ var s=document.createElement('script'); if(old.type)s.type=old.type; if(old.id)s.id=old.id; s.textContent=old.textContent; old.parentNode.replaceChild(s, old); }); }
  var pdpInjectT=null;
  function pdpFallback(url, msg){ return '<div class="bbw-pdp-loading">'+msg+'<br><a href="'+url+'" style="color:var(--deep);font-weight:700;text-decoration:none">前往商品頁查看 →</a></div>'; }
  function openPdp(pid, url){
    if(!pdpSheet||!pdpBody) return;
    pdpBody.scrollTop=0;
    pdpBody.innerHTML='<div class="bbw-pdp-loading">載入中…</div>';
    requestAnimationFrame(function(){ pdpBd.classList.add('is-show'); pdpSheet.classList.add('is-show'); root.classList.add('bbw-has-sheet'); });
    clearTimeout(pdpInjectT);
    pdpInjectT=setTimeout(function(){                       // inject after the slide settles -> smooth animation
      try{
        var tpl=root.querySelector('template[data-pdp-tpl="'+pid+'"]');
        if(tpl && tpl.content && tpl.content.childNodes.length){ pdpBody.innerHTML=''; pdpBody.appendChild(tpl.content.cloneNode(true)); runScripts(pdpBody); }
        else if(url){ pdpBody.innerHTML=pdpFallback(url,'沒有載入到商品詳情'); }
      }catch(err){ if(url) pdpBody.innerHTML=pdpFallback(url,'這支暫時無法在這裡顯示'); }
      pdpBody.scrollTop=0;
    }, 360);
  }
  function closePdp(){
    if(!pdpSheet) return;
    clearTimeout(pdpInjectT);
    pdpSheet.classList.remove('is-show'); if(pdpBd) pdpBd.classList.remove('is-show');
    if((!pmodal||!pmodal.classList.contains('is-show'))&&(!nsheet||!nsheet.classList.contains('is-show'))) root.classList.remove('bbw-has-sheet');
    setTimeout(function(){ if(pdpBody&&!pdpSheet.classList.contains('is-show')) pdpBody.innerHTML=''; }, 450);
  }
  root.querySelectorAll('[data-pdp-open]').forEach(function(b){ b.addEventListener('click', function(){ openPdp(b.dataset.pid, b.dataset.url); }); });
  if(pdpBd) pdpBd.addEventListener('click', closePdp);
  root.querySelectorAll('[data-pdp-close]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); closePdp(); }); });

  /* ---------- photo lightbox (tap a photo -> big, swipeable) ---------- */
  var lb=root.querySelector('[data-lb]'), lbBd=root.querySelector('[data-lb-bd]'), lbTrack=lb?lb.querySelector('[data-lb-track]'):null;
  function openLb(shot){
    if(!lb||!lbTrack) return;
    var strip=shot.closest('.bbw-shots'); if(!strip) return;
    var shots=[].slice.call(strip.querySelectorAll('.bbw-shot[data-full]'));
    var idx=shots.indexOf(shot); if(idx<0) idx=0;
    lbTrack.innerHTML=shots.map(function(s){ return '<div class="bbw-lb-slide"><img class="bbw-lb-img" src="'+s.getAttribute('data-full')+'" alt=""></div>'; }).join('');
    lb.classList.add('is-show'); if(lbBd) lbBd.classList.add('is-show');
    requestAnimationFrame(function(){ lbTrack.scrollLeft = idx * lbTrack.clientWidth; });
  }
  function closeLb(){
    if(!lb) return;
    lb.classList.remove('is-show'); if(lbBd) lbBd.classList.remove('is-show');
    setTimeout(function(){ if(!lb.classList.contains('is-show')&&lbTrack) lbTrack.innerHTML=''; }, 300);
  }
  root.querySelectorAll('.bbw-shot[data-zoom]').forEach(function(s){ s.addEventListener('click', function(){ openLb(s); }); });
  if(lbBd) lbBd.addEventListener('click', closeLb);
  root.querySelectorAll('[data-lb-close]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); closeLb(); }); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'&&lb&&lb.classList.contains('is-show')) closeLb(); });

  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ if(pdpSheet&&pdpSheet.classList.contains('is-show')) closePdp(); else if(nsheet.classList.contains('is-show')) closeNotes(); else if(pmodal.classList.contains('is-show')) closeP(); } });

  /* ---------- image gallery: swipe → variant label + dots ---------- */
  root.querySelectorAll('[data-gallery]').forEach(function(g){
    var slides = g.children;
    if(slides.length === 0) return;
    var wrap = g.parentElement;
    var label = wrap.querySelector('[data-vlabel]');
    var dots = null;
    if(slides.length > 1){
      dots = document.createElement('div'); dots.className = 'bbw-dots';
      for(var i=0;i<slides.length;i++){ var d=document.createElement('span'); d.className='bbw-dot'+(i===0?' is-on':''); dots.appendChild(d); }
      wrap.appendChild(dots);
    }
    function paint(){
      var idx = Math.round(g.scrollLeft / Math.max(g.clientWidth,1));
      idx = Math.max(0, Math.min(slides.length-1, idx));
      var s = slides[idx];
      if(label && s && s.dataset.label){ label.textContent = s.dataset.label; label.classList.add('is-show'); }
      if(dots){ for(var i=0;i<dots.children.length;i++){ dots.children[i].classList.toggle('is-on', i===idx); } }
    }
    paint();
    var raf;
    g.addEventListener('scroll', function(){ if(raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, {passive:true});
  });

  /* prime cart state on load */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    cart.items.forEach(function(i){ qty[i.variant_id]=i.quantity; syncVariant(i.variant_id,i.quantity); });
    paintCart(cart);
  }).catch(function(){});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shortcut-pills"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'aj_recently_viewed_collections';
    var MAX_ITEMS = 10;

    // --- Track collection visits ---
    function trackCollectionView() {
      var path = window.location.pathname;
      // Match /collections/{handle} but not /collections/all or listing page
      var match = path.match(/^\/collections\/([^\/\?#]+)/);
      if (!match) return;

      var handle = match[1];
      // Skip the catch-all "all" collection and any product-in-collection URLs
      if (!handle || handle === 'all') return;
      // Skip /collections/xxx/products/yyy (we only want pure collection views)
      if (path.indexOf('/products/') !== -1) return;

      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(list)) list = [];

        // Remove if already exists, then prepend
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        list = list.slice(0, MAX_ITEMS);

        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {
        // localStorage blocked — silently fail
      }
    }

    // --- Reveal the recently-viewed-collection pill if user has history ---
    function revealRecentlyViewed() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(list) || list.length === 0) return;

        var pills = document.querySelectorAll('[data-recently-viewed-collection-pill]');
        pills.forEach(function (pill) {
          var currentHref = pill.getAttribute('href');
          // Only override href if no fallback URL was set
          if (!currentHref || currentHref === '#' || currentHref === '') {
            pill.setAttribute('href', '/collections/' + list[0]);
          }
          pill.classList.remove('is-hidden');
        });
      } catch (e) {
        // silently fail
      }
    }

    function init() {
      trackCollectionView();
      revealRecentlyViewed();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
